import Vue from 'vue';
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from '@/mixins/HttpMixin';
import flatPickr from 'vue-flatpickr-component';
import GenericModal from '@/componentsReusable/genericModal.vue';

export default Vue.component('ready-to-pay', {
  name: 'ReadyToPay',
  components: {
    VueSimpleSpinner,
    flatPickr,
    GenericModal
  },
  mixins: [ HttpMixin ],
  data () {
    return {
      cardExpanded: false,
      loadingInitialData: false,
      toBePaidDate: new Date(),
      showConfirmationModal: false,
      providers: [],
      total: 0,
      canPay: false
    };
  },
  computed: {
    confirmationText (): string {
      let formattedDate = (this.$options as any).filters.nmrDateFormat(this.toBePaidDate);
      formattedDate = '<span class="color-green">' + formattedDate + '</span>';
      return 'Are you sure you want to mark these providers as paid?<br/><br/> \
        The "To Be Paid Date" will be: ' + formattedDate + '<br/><br/> \
        The following will occur: <br/><br/> \
        &#8226; These Providers will display as paid on ' + formattedDate + '<br/> \
        &#8226; PDF Provider Bill Receipts will be emailed on ' + formattedDate + '<br/> \
        &#8226; PDF Provider Bill Receipts will be available in the Provider Portal on ' + formattedDate + '<br/> \
        ';
    },
    readyToPayCounter (): number {
      return this.$store.state.invoices.readyToPayCounter;
    }
  },
  watch: {
    async readyToPayCounter () {
      await this.fetch();
    }
  },
  mounted () {
    // Setting the "toBePaidDate" to the next Friday
    if (this.toBePaidDate.getDay() < 5) {
      this.toBePaidDate.setDate( this.toBePaidDate.getDate() + (5 - this.toBePaidDate.getDay()) )
    } else if (this.toBePaidDate.getDay() > 5) {
      this.toBePaidDate.setDate( this.toBePaidDate.getDate() + (5 - this.toBePaidDate.getDay() + 7) )
    }
  },
  async created () {
    await this.expandCard();
  },
  methods: {
    async expandCard(): Promise<void> {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.fetch();
      }
    },
    async fetch() {
      const results = await Promise.all([
        (this as any).httpGet('/provider-payments/queue?isReadyToPay=true&isCountOnly=false', 'An error occurred retrieving Providers.'),
        (this as any).httpGet('/provider-payments/recent-paid', 'An error occurred retrieving Recently Paid Providers.')
      ]);
      this.providers = results[0];
      this.canPay = results[1].length === 0;
      this.total = this.providers.map((provider: any) => provider.amount).reduce((prev, current) => prev + current, 0);
    },
    async sendToPayQueue (invoiceId = 0, providerId = 0) {
      await (this as any).httpPut(`/provider-payments/queue?readyToPay=false&invoiceId=${invoiceId}&providerId=${providerId}`, 'An error occurred marking Provider(s) Ready to Pay.', null, false);
      await this.fetch();
      this.$store.commit('invoices/readyToQueue');
    },
    async markPaid () {
      this.showConfirmationModal = true;
    },
    async payProviders () {
      const body = { paidDate: this.toBePaidDate };
      await (this as any).httpPost('/provider-payments', 'Error marking Providers as Paid.', body, false);
      await this.fetch();
      this.$store.commit('invoices/updatePaidCounter');
      this.showConfirmationModal = false;
    },
    browseToProvider (providerId: number) {
      window.open("/providers/" + providerId, '_blank');
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/payments/cards/readyToPay/ReadyToPay.ts